import STLViewer from 'stl-viewer';
import THREE from 'stl-viewer/src/Three';

class MyStlViewer extends STLViewer
{
	componentDidMount() {
		super.componentDidMount();

		this.paint._addCamera = this.paint.addCamera;

		this.paint.addCamera = () => {
			this.paint._addCamera();

			const camera = this.paint.camera;

			const ambientLight = new THREE.AmbientLight(0x202020);
			camera.add(ambientLight);

			const directionalLight = new THREE.DirectionalLight(0xffffff, 0.75);
			directionalLight.position.x = 1;
			directionalLight.position.y = 1;
			directionalLight.position.z = 2;
			directionalLight.position.normalize();
			camera.add(directionalLight);

			const pointLight = new THREE.PointLight(0xffffff, 0.3);
			pointLight.position.x = 0;
			pointLight.position.y = -25;
			pointLight.position.z = 10;
			camera.add(pointLight);
		};
	}

	componentWillUnmount() {
		try {
			super.componentWillUnmount();
		} catch (e) {

		}
	}
}

export default MyStlViewer;



// WEBPACK FOOTER //
// ./src/react/ui/MyStlViewer.jsx